import { useState, useEffect } from 'react';
import { apiFetch } from '../api/client';

export function useContent() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiFetch('/content.php')
      .then(data => setContent(data))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const saveContent = async (newContent) => {
    await apiFetch('/content.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newContent),
    });
    setContent(newContent);
  };

  return { content, loading, error, saveContent };
}
